// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const PipRequiredItem = t.struct({
    amount: t.Number,
    currency: t.String,
    description: t.String,
    key: t.String,
    quantity: t.Number,
    type: t.String,
    unit: t.String
}, {
    name: 'PipRequiredItem',
    strict: true
});

export const getDefaultState = () => new PipRequiredItem({
    amount: 0,
    currency: '',
    description: '',
    key: '',
    quantity: 0,
    type: '',
    unit: ''
});

export default PipRequiredItem;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/pip-required-item.js